import React from 'react';
export var ReactReduxContext = React.createContext(null);
export default ReactReduxContext;


//////////////////
// WEBPACK FOOTER
// ../react-redux/es/components/Context.js
// module id = 399
// module chunks = 25